import {FC} from 'react';
import styled from 'styled-components';

type Props = {
  columns: Column[];
  data: Record<string, any>[];
};

export type Column = {
  title: string;
  key: string;
  width?: string;
};

const Table: FC<Props> = ({columns, data}) => {
  return (
    <TableContainer>
      <table cellPadding={0} cellSpacing={0} border={0}>
        <thead>
          <tr>
            {columns.map(item => (
              <th key={item.key} style={{width: item.width ? item.width : ''}}>
                {item.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((record, index) => (
            <tr key={index}>
              {columns.map(item =>
                record[item.key] ? (
                  <td
                    key={item.key}
                    style={{width: item.width ? item.width : ''}}
                    rowSpan={
                      record.rowSpan && item.key === 'day' ? record.rowSpan : 1
                    }>
                    {typeof record[item.key] === 'function'
                      ? record[item.key]()
                      : record[item.key]}
                  </td>
                ) : null
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default Table;

const TableContainer = styled.div`
  padding: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  table {
    border: 2px solid #bba688;
    border-bottom: 0;
    width: 100%;
  }
  td {
    text-align: center;
  }
  thead {
    tr > th {
      text-align: center;
      color: #CD5629;
      padding: 0.1rem 0.8rem;
    }
  }
  tr {
    td,
    th {
      border-bottom: 2px solid #dbc8af;
      padding: 0.1rem 0.8rem;
    }
    td:not(:last-child),
    th:not(:last-child) {
      border-right: 1px solid #dbc8af;
    }
  }
  tbody {
    tr {
    }
  }
`;
